import { render, staticRenderFns } from "./EmployeeLeaveSummaries.vue?vue&type=template&id=2ca4bd40&scoped=true"
import script from "./EmployeeLeaveSummaries.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4bd40",
  null
  
)

export default component.exports